import { AppBase } from "./appBase";
import ImgGallery from "./entities/imgGallery";

class AppBrandIdentity extends AppBase {
    protected _init() {
        super._init();
        new ImgGallery(document.querySelector("[data-img-gallery]"));
    }
}

export const app = new AppBrandIdentity();